import { gql, useQuery } from "@apollo/client";
import React, { useCallback, useEffect, useState } from "react";
import ChartAndTable from "./ChartAndTable";
import { getRandomColor, prepareChartDataOne, prepareChartDataTwo, processDataForDWMLoads } from "./prepareChartData";
// import RefreshButton from "./RefreshButton";
import { Loading } from "../../Components";
import Select from "react-select";
import "./Dashboard.scss";
import RefreshIcon from "./RefreshIcon";

const DashBoardQuery = gql`
  query Query($timeFrame: String!) {
    getLoadPostDynamicByAccountManager(timeFrame: $timeFrame)
  }
`;

const customStyles = {
  container: (provided) => ({
    ...provided,
    width: "100px",
    marginLeft: "1%",
  }),
  control: (provided) => ({
    ...provided,
    backgroundColor: "#f0f0f0",
    border: "1px solid #ccc",
    boxShadow: "none",
    fontSize: "12px",
    padding: "0px",
    "&:hover": {
      borderColor: "#888",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#888",
    fontSize: "12px",
    padding: "0px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#999999",
    fontSize: "11px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    fontSize: "11px",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "150px",
    overflowY: "auto",
    fontSize: "11px",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#b3e5b4" : state.isFocused ? "#4caf50" : base.backgroundColor,
    color: state.isSelected || state.isFocused ? "#fff" : "#333",
    fontSize: "11px",
    "&:active": {
      backgroundColor: "#b3e5b4",
      color: "#fff",
    },
    "&:hover": {
      backgroundColor: "#4caf50",
      color: "#fff",
    },
  }),
};

const LoadPostChartAndTable = () => {
  const Key = "Loads_Post_Dynamic_By_Account_Manager";
  const [theme, setTheme] = useState("Theme1");
  const [timeFrame, setTimeFrame] = useState({ value: "daily", label: "Daily" });
  const [colors, setColors] = useState({});
  
  const [TableData, setTableData] = useState([]);
  const [chartData, setChartData] = useState({});
  const [maxNumber, setMaxNumber] = useState(10000);
  const [options, setOption] = useState({});
  const [colAddition, setcolAddition] = useState([]);
  const selectOptions = [
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
  ];

  // Function to handle changes in the Select component
  const handleSelectChange = (selectedOption) => {
    setTimeFrame(selectedOption);
  };

  const { data, loading, error, refetch, networkStatus } = useQuery(DashBoardQuery, {
    variables: { timeFrame: timeFrame.value },
    context: { headers: { "X-GraphQL-Server": "secondary" } },
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (data?.getLoadPostDynamicByAccountManager) {
      const { colAddition, updatedData } = processDataForDWMLoads(data?.getLoadPostDynamicByAccountManager);
      console.log(updatedData, "updatedData");
      setTableData(updatedData);
      setcolAddition(colAddition);
    }
  }, [data]);

  useEffect(() => {
    const newColors = {};
    if (data?.getLoadPostDynamicByAccountManager) {
      data.getLoadPostDynamicByAccountManager.forEach((dateObj) => {
        const loads = dateObj[Object.keys(dateObj)[0]].loads;
        loads.forEach((load) => {
          if (!colors[load.Full_Name]) {
            newColors[load.Full_Name] = getRandomColor();
          }
        });
      });
      setColors((prevColors) => ({ ...prevColors, ...newColors }));
    }
  }, [data, theme]);

  useEffect(() => {
    if (data?.getLoadPostDynamicByAccountManager) {
      let preparedData;
      if (theme === "Theme1") {
        preparedData = prepareChartDataOne(data.getLoadPostDynamicByAccountManager, colors);
      } else {
        preparedData = prepareChartDataTwo(data.getLoadPostDynamicByAccountManager, "#2ca01c", "Total Load Posts");
      }

      setChartData(preparedData);
      const max = preparedData.datasets?.reduce((max, dataset) => Math.max(max, ...dataset.data), 0) || 0;
      setMaxNumber(max + max * 0.1);
    }
  }, [data, colors, theme]);

  useEffect(() => {
    const options1 = {
      responsive: true,
      plugins: {
        legend: { position: "top" },
        title: { display: false, text: "Load Posts" },
      },
      scales: {
        x: {
          reverse: true,
          time: {
            unit: timeFrame === "monthly" ? "month" : timeFrame === "weekly" ? "week" : "day",
            tooltipFormat: timeFrame === "monthly" ? "yyyy-MM" : "yyyy-MM-dd",
            displayFormats: { day: "yyyy-MM-dd", week: "yyyy-WW", month: "yyyy-MM" },
          },
          title: { display: true, text: "Date" },
          ticks: { maxRotation: 90, minRotation: 90, autoSkip: false },
        },
        y: { min: 0, max: maxNumber, ticks: { stepSize: 10 }, title: { display: true, text: "Load Count" } },
      },
    };

    const options2 = {
      responsive: true,
      plugins: {
        legend: { position: "top" },
        title: { display: false, text: "Load Posts" },
        tooltip: {
          callbacks: {
            label: function (context) {
              return context.dataset.label + " : " + context.parsed.y;
            },
            afterBody: function (tooltipItems) {
              const tooltipIndex = tooltipItems[0].dataIndex;
              const details = chartData.tooltips[tooltipIndex];
              return details;
            },
          },
        },
      },
      scales: {
        x: {
          reverse: true,
          time: {
            unit: timeFrame === "monthly" ? "month" : timeFrame === "weekly" ? "week" : "day",
            tooltipFormat: timeFrame === "monthly" ? "yyyy-MM" : "yyyy-MM-dd",
            displayFormats: { day: "yyyy-MM-dd", week: "yyyy-WW", month: "yyyy-MM" },
          },
          title: { display: true, text: "Date" },
          ticks: { maxRotation: 90, minRotation: 90, autoSkip: false, stepSize: 1 },
        },
        y: {
          beginAtZero: true,
          min: 0,
          max: maxNumber,
          ticks: { stepSize: 10 },
          title: { display: true, text: "Load Count" },
        },
      },
    };

    setOption(theme === "Theme1" ? options1 : options2);
  }, [timeFrame, maxNumber]);

  // useEffect(() => {
  //   let interval;
  //   if (isActive) {
  //     interval = setInterval(() => {
  //       setTime((prevTime) => prevTime + 1);
  //     }, 1000);
  //   }
  //   return () => clearInterval(interval);
  // }, [isActive]);

  // const handleRefresh = useCallback(() => {
  //   setIsActive(false);
  //   refetch().finally(() => {
  //     setIsActive(true);
  //     setTime(0);
  //   });
  // }, [refetch]);

  const isRefetching = networkStatus === 4;
  const isLoading = isRefetching || loading || chartData?.length <= 0 || TableData?.length <= 0;

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <>
      <div className="title_With_Loading_Logo">
        <div className="load-post-title">Load Post By Erp User</div>
        <div className="load-post-logo">
          <RefreshIcon handleRefetch={refetch} loading={loading} />
        </div>
      </div>
      <div className="Load_Post_Chart_And_Table">
        <div style={{ marginLeft: "1%" }}>
          <input
            type="radio"
            name="theme"
            value="Theme1"
            checked={theme === "Theme1"}
            onChange={() => setTheme("Theme1")}
          />
          Theme1
          <input
            type="radio"
            name="theme"
            value="Theme2"
            checked={theme === "Theme2"}
            onChange={() => setTheme("Theme2")}
          />
          Theme2
        </div>
        <div className="Load_Post_Chart_And_Table_Child_Two" style={{ marginLeft: "2%" }}>
          <div>
            <label htmlFor="timeFrameSelect">Time Frame:</label>
          </div>
          <div>
            <Select
              value={selectOptions.value}
              onChange={handleSelectChange}
              options={selectOptions}
              placeholder={timeFrame.label}
              styles={customStyles}
            />
          </div>
        </div>
        <div style={{ marginLeft: "5%" }}>
          {/* <RefreshButton
            isRefetching={isRefetching}
            onRefresh={handleRefresh}
            time={{ hours: Math.floor(time / 3600), minutes: Math.floor((time % 3600) / 60), seconds: time % 60 }}
          /> */}
        </div>
      </div>
      <ChartAndTable
        chartData={chartData}
        options={options}
        data={TableData}
        error={error}
        tableKey={Key}
        colAddition={colAddition}
      />
    </>
  );
};

export default LoadPostChartAndTable;
